import { ReactElement } from "react";

export const UploadIcon = ({ ...props }): ReactElement => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.35953 7.2222C1.00422 7.52317 1.21706 8.10373 1.68271 8.10373H6.01309C6.28923 8.10373 6.51309 8.32758 6.51309 8.60372V20.3077C6.51309 20.5838 6.73695 20.8077 7.01309 20.8077H12.9816C13.2578 20.8077 13.4816 20.5838 13.4816 20.3077V8.60373C13.4816 8.32758 13.7055 8.10373 13.9816 8.10373H18.4554C18.921 8.10373 19.1339 7.52317 18.7786 7.2222L10.3922 0.118477C10.2057 -0.0394924 9.93237 -0.0394924 9.74588 0.118477L1.35953 7.2222ZM1.78806 22.9229C0.938341 22.9229 0.249512 23.6117 0.249512 24.4614C0.249512 25.3111 0.938341 26 1.78805 26H18.212C19.0617 26 19.7505 25.3111 19.7505 24.4614C19.7505 23.6117 19.0617 22.9229 18.212 22.9229H1.78806Z"
      />
    </svg>
  );
};
